var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopularCountries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17565",
    "data-name": "Group 17565",
    transform: "translate(-919 -654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag",
    transform: "translate(844.666 658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17440",
    "data-name": "Group 17440",
    transform: "translate(80.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8351",
    "data-name": "Path 8351",
    d: "M89.07.525A3.63,3.63,0,0,0,87.15,0a8.7,8.7,0,0,0-2.465.487,8.019,8.019,0,0,1-2.246.455h0A2.893,2.893,0,0,1,81.1.628V.381a.381.381,0,0,0-.762,0V12.619a.381.381,0,0,0,.762,0V6.638a3.68,3.68,0,0,0,1.343.242A8.7,8.7,0,0,0,84.9,6.394a8.017,8.017,0,0,1,2.246-.455,2.889,2.889,0,0,1,1.528.417.381.381,0,0,0,.577-.327V.852A.381.381,0,0,0,89.07.525Z",
    transform: "translate(-80.334 0)",
    fill: "#c22127"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    width: 20,
    height: 20,
    transform: "translate(919 654)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularCountries);
export default __webpack_public_path__ + "static/media/popular_countries.00d382c14b5eb232788bfe46fb4de356.svg";
export { ForwardRef as ReactComponent };